// Angular
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// Fake API Angular-in-memory
// Translate Module
import { TranslateModule } from '@ngx-translate/core';
// NGRX
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
// UI
import { PartialsModule } from '../../../partials/partials.module';
// Auth
import { ModuleGuard } from '../../../../core/auth';
// Core => Services

// Core => Utils
import {
  HttpUtilsService,
  TypesUtilsService,
  InterceptService,
  LayoutUtilsService,
} from '../../../../core/_base/crud';
// Shared
import {
  ActionNotificationComponent,
  DeleteEntityDialogComponent,
  FetchEntityDialogComponent,
  UpdateStatusDialogComponent,
  ConfirmActionDialogComponent,
} from '../../../partials/content/crud';

// Material
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { NgbProgressbarModule, NgbTooltipModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPermissionsModule } from 'ngx-permissions';
import { TimelineComponent } from './timeline.component';
import { MatChipsModule } from '@angular/material/chips';
import { MeetingsListComponent } from './meetings/meetings-list/meetings-list.component';
import { MeetingEditComponent } from './meetings/meeting-edit/meeting-edit.component';
import { MessageEditComponent } from './messages/message-edit/message-edit.component';
import { MeetingViewDialogComponent } from './meetings/meeting-view/meeting-view-dialog.component';
import { MessageViewComponent } from './messages/message-view/message-view.component';
import { MeetingService } from 'src/app/core/timeline/_services/meeting.service';
import { meetingsReducer } from 'src/app/core/timeline/_reducers/meeting.reducers';
import { MeetingEffects } from 'src/app/core/timeline/_effects/meeting.effects';
import { MessageEffects } from 'src/app/core/timeline/_effects/message.effects';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { messagesReducer, MessageService } from 'src/app/core/timeline';

import { SendEmailFaxComponent } from './send-email-fax/send-email-fax.component';
import {
  ContactsService,
  PatientsService,
  DoctorService,
  FacilitiesService,
  DrugService,
  AffiliationsService,
} from 'src/app/core/lists/_services';
import { CommunicationsService } from 'src/app/core/timeline/_services';
import { UserService } from 'src/app/core/auth/_services';
import { AttachmentsListComponent } from './attachments/attachments-list/attachments-list.component';
import { ViewCommunicationComponent } from './view-communication/view-communication.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { InlineSVGModule } from 'ng-inline-svg';
import { FilteredViewInterceptor } from '../../../../core/auth/_helpers/filtered-view.interceptor';
import { CreateContactDialogComponent } from '../../../partials/content/general/contact-add-dialog/contact-add.dialog.component';
import { ContactEffects, contactsReducer } from '../../../../core/lists';
import { PatientModReviewComponent } from '../lists/patients/patient-mod-review/patient-mod-review.component';
import { CoreModule } from '../../../../core/core.module';
import { SalesTeamsListComponent } from './sales-teams/sales-teams-list/sales-teams-list.component';
import { SalesTeamViewDialogComponent } from './sales-teams/sales-team-view/sales-team-view-dialog.component';
import { SalesTeamEditComponent } from './sales-teams/sales-team-edit/sales-team-edit.component';
import { salesTeamsReducer } from '../../../../core/timeline/_reducers/sales-team.reducers';
import { SalesTeamEffects } from '../../../../core/timeline/_effects/sales-team.effects';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TargetListComponent } from './sales-teams/target-list/target-list.component';
import { QuillModule } from 'ngx-quill';

// tslint:disable-next-line:class-name
const routes: Routes = [
  {
    path: '',
    component: TimelineComponent,
    // canActivate: [ModuleGuard],
    // data: { moduleName: 'ecommerce' },
    children: [
      {
        path: '',
        redirectTo: 'meetings',
        pathMatch: 'full',
      },
      {
        path: 'meetings',
        canActivate: [ModuleGuard],
        data: { permissionName: 'accessToMeetingModule' },
        component: MeetingsListComponent,
      },
      {
        path: 'sales-team',
        canActivate: [ModuleGuard],
        data: { permissionName: 'accessToSalesTeamsModule' },
        component: SalesTeamsListComponent,
      },
      {
        path: 'meetings/add',
        canActivate: [ModuleGuard],
        data: { permissionName: 'accessToMeetingModule' },
        component: MeetingEditComponent,
      },
      {
        path: 'meetings/edit',
        canActivate: [ModuleGuard],
        data: { permissionName: 'accessToMeetingModule' },
        component: MeetingEditComponent,
      },
      {
        path: 'meetings/edit/:id',
        canActivate: [ModuleGuard],
        data: { permissionName: 'accessToMeetingModule' },
        component: MeetingEditComponent,
      },
      {
        path: 'messages/add',
        canActivate: [ModuleGuard],
        data: { permissionName: 'canSendMessage' },
        component: MessageEditComponent,
      },
      // {
      // 	path: 'messages/add:id',
      // 	component: MessageEditComponent
      // },
      {
        path: 'messages/edit',
        canActivate: [ModuleGuard],
        data: { permissionName: 'canSendMessage' },
        component: MessageEditComponent,
      },
      {
        path: 'messages/edit/:id',
        canActivate: [ModuleGuard],
        data: { permissionName: 'canSendMessage' },
        component: MessageEditComponent,
      },
      {
        path: 'send/email',
        canActivate: [ModuleGuard],
        data: { permissionName: 'canSendEmail' },
        component: SendEmailFaxComponent,
      },
      {
        path: 'send/fax',
        canActivate: [ModuleGuard],
        data: { permissionName: 'canSendFax' },
        component: SendEmailFaxComponent,
      },
    ],
  },
];

@NgModule({
  imports: [
    NgbModule,
    MatDialogModule,
    CommonModule,
    MatChipsModule,
    HttpClientModule,
    PerfectScrollbarModule,
    PartialsModule,
    NgxPermissionsModule.forChild(),
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    MatButtonModule,
    MatMenuModule,
    MatSelectModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatInputModule,
    MatTableModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatIconModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatCardModule,
    MatPaginatorModule,
    MatSortModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatTabsModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatDividerModule,
    MatButtonToggleModule,
    NgbProgressbarModule,
    NgbTooltipModule,
    StoreModule.forFeature('contacts', contactsReducer),
    EffectsModule.forFeature([ContactEffects]),
    StoreModule.forFeature('meetings', meetingsReducer),
    EffectsModule.forFeature([MeetingEffects]),
    StoreModule.forFeature('messages', messagesReducer),
    EffectsModule.forFeature([MessageEffects]),
    StoreModule.forFeature('salesTeams', salesTeamsReducer),
    EffectsModule.forFeature([SalesTeamEffects]),
    InlineSVGModule,
    CoreModule,
    DragDropModule,
    QuillModule,
  ],
  providers: [
    DatePipe,
    ModuleGuard,
    InterceptService,
    AffiliationsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FilteredViewInterceptor,
      multi: true,
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        hasBackdrop: true,
        panelClass: 'mat-dialog-container-wrapper',
        height: 'auto',
        width: '900px',
      },
    },
    TypesUtilsService,
    LayoutUtilsService,
    HttpUtilsService,
    MeetingService,
    MessageService,
    TypesUtilsService,
    LayoutUtilsService,
    DatePipe,
    ContactsService,
    UserService,
    PatientsService,
    DoctorService,
    FacilitiesService,
    CommunicationsService,
    DrugService,
  ],
  entryComponents: [
    ActionNotificationComponent,
    ConfirmActionDialogComponent,
    DeleteEntityDialogComponent,
    FetchEntityDialogComponent,
    UpdateStatusDialogComponent,
    MeetingViewDialogComponent,
    MessageViewComponent,
    ViewCommunicationComponent,
    CreateContactDialogComponent,
    PatientModReviewComponent,
    SalesTeamViewDialogComponent,
    SalesTeamEditComponent,
    TargetListComponent,
  ],
  declarations: [
    AttachmentsListComponent,
    TimelineComponent,
    MeetingEditComponent,
    MeetingsListComponent,
    MeetingViewDialogComponent,
    MessageViewComponent,
    MessageEditComponent,
    SendEmailFaxComponent,
    ViewCommunicationComponent,
    SalesTeamsListComponent,
    TargetListComponent,
    SalesTeamViewDialogComponent,
    SalesTeamEditComponent,
  ],
  exports: [
    AttachmentsListComponent,
    MeetingViewDialogComponent,
    ViewCommunicationComponent,
    SalesTeamViewDialogComponent,
    SalesTeamsListComponent,
  ],
})
export class TimelineModule {}
